import { MapContainer, TileLayer, Marker, Polyline, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const numIcon = (n) =>
  L.divIcon({
    className: "",
    html: `<div style="width:28px;height:28px;border-radius:50%;background:linear-gradient(135deg,#f43f5e,#9333ea);color:#fff;font-weight:900;font-size:13px;display:flex;align-items:center;justify-content:center;border:2.5px solid #fff;box-shadow:0 2px 8px rgba(0,0,0,0.3)">${n}</div>`,
    iconSize: [28, 28],
    iconAnchor: [14, 14],
  });

export const TrailMap = ({ stops }) => {
  const pts = stops.map((s) => [s.lat, s.lng]);
  const bounds = L.latLngBounds(pts).pad(0.35);

  return (
    <div data-testid="trail-map" className="rounded-3xl overflow-hidden border border-slate-100" style={{ position: "relative", zIndex: 0 }}>
      <MapContainer bounds={bounds} scrollWheelZoom={false} style={{ height: 380, width: "100%" }}>
        <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' url="https://tile.openstreetmap.org/{z}/{x}/{y}.png" />
        {pts.length > 1 && <Polyline positions={pts} pathOptions={{ color: "#db2777", weight: 3, dashArray: "8 8" }} />}
        {stops.map((s, i) => (
          <Marker key={s.id} position={[s.lat, s.lng]} icon={numIcon(i + 1)}>
            <Popup>
              <strong>{s.name}</strong>
              <br />
              {s.type}
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
};

export default TrailMap;
